import * as React from 'react';
import {ModalGeneric} from '../modal-generic';
import {percent, px} from 'csx';
import {style} from 'typestyle';
import {colorSubtle} from '../../theme/color';
import {ButtonPill} from '../button-pill';

type Props = {
  title?: string;
  caption?: string;
  embed: string;
  children?(Modal: any, showModal: () => () => any): any;
}

type State = {
  show: boolean;
}

export default class VideoModal extends React.Component<Props, State> {
  state: State = {
    show: false
  };

  render() {
    const {caption, title, embed, children} = this.props;
    const {show} = this.state;

    const modal = (
      <ModalGeneric model={{show}} onRequestClose={this.hide}>
        {title && <h3>{title}</h3>}
        <div className={VideoModal.styles.video}>
          <div dangerouslySetInnerHTML={{__html: embed}} />
        </div>
        {caption && (
          <i className={VideoModal.styles.caption}>
            {caption}
          </i>
        )}
      </ModalGeneric>
    );

    const button = (
      <ButtonPill onClick={this.show}>Watch</ButtonPill>
    );

    return !children
      ? show
        ? modal
        : button
      : children(modal, this.show);
    }

  private show = () => {
    this.setState({show: true});
    return this.hide;
  };

  private hide = () => this.setState({show: false});

  static styles = {
    video: style({
      width: percent(100),
      marginTop: px(20),
      $nest: {
        '& iframe': {
          maxWidth: percent(100)
        }
      },
    }),
    caption: style({
      display: 'block',
      margin: '1rem 0',
      fontStyle: 'italic',
      color: colorSubtle.toString()
    })
  }
}